@if (isHandset()) {
  <div style="height: 60px"></div>
}
@if (searchCounters.length > 0) {
  <div style="display: flex; flex-wrap: wrap">
    @for (searchCounter of searchCounters; track searchCounter.entity_id) {
      <mat-card
        style="min-width: 120px; height: 120px; margin: 10px; cursor: pointer"
        [class.background-primary]="
          selectedEntity?.entity_code == searchCounter.entity.entity_code
        "
        [class.highlightColor]="
          selectedEntity?.entity_code == searchCounter.entity.entity_code
        "
        (click)="showEntityResults(searchCounter.entity)"
      >
        <div class="innerNumDiv">
          <div class="resNum">
            {{ searchCounter.find_counter }}
          </div>
          <mat-divider [vertical]="true" style="margin: 5px"></mat-divider>
          <div style="margin-top: 45px; width: 100%">
            {{ searchCounter | translateEntityLabel }}
          </div>
        </div>
      </mat-card>
    }
  </div>
} @else {
  <div style="width: 100%">
    <div class="outerNoResult">
      <div class="noResult">{{ 'welcome.noResults' | translate }}</div>
    </div>
  </div>
}
<div>
  <mat-divider style="margin: 5px"></mat-divider>
</div>
@for (searchCounter of searchCounters; track searchCounter.entity_id) {
  @if (selectedEntity?.entity_code == searchCounter.entity.entity_code) {
    <app-data-list
      [ENTITY]="searchCounter.entity.entity_code"
      [entityFilters]="entityFilters"
      [SHOWSEARCH]="false"
      [SHOWTRASHFILTER]="false"
      (selectEntityItem)="previewItem($event, selectedEntity.entity_code)"
    ></app-data-list>
  }
}
